import { getGlobalParamsListItemLabel } from '@/utils/common'
import store from '@/store'

export const contentTableConfig = {
  title: '',
  propList: [
    {
      prop: 'name',
      label: 'general.name',
      width: 180
    },
    {
      prop: 'tableId',
      label: 'general.router-geo-fence',
      formatter: (row) => {
        return getGlobalParamsListItemLabel(row, 'geoFenceList', {
          isNeedPreFix: false
        })
      }
    },
    {
      prop: 'groupId',
      label: 'geoFence.geo-fence-group-name',
      formatter: (row) => {
        return getGlobalParamsListItemLabel(row, 'geoFenceGroupList', {
          isNeedPreFix: false
        })
      }
    },
    {
      prop: 'tenantId',
      label: 'user.tenant',
      width: 180,
      formatter: (row) => {
        return row ? store.getters.tenantDataMap[row] : ''
      }
    },
    {
      prop: 'description',
      label: 'general.description'
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time'
    },
    {
      label: 'common.app-operation',
      width: '400',
      slotName: 'handler'
    }
  ],
  showIndexColumn: true
}
